import * as ApiUrls from "./ApiUrl.CoreExport";
import { AxiosResponse } from "axios";
import { axiosCoreInstance } from "../AxiosCoreInterceptor";
import { Export } from "../../Model/Dto/Export";



export const CoreExportService = {
  ExportFile: (data: Export.FileExportDto): Promise<AxiosResponse<string>> => {
    return axiosCoreInstance.post(ApiUrls.FileExport, data);
  },
  FileExportFunction: (data: Export.DynamicFileExportDto): Promise<AxiosResponse<string>> => {
    return axiosCoreInstance.post(ApiUrls.FileExportFunction, data);
  }
}

